import { QueryClientProvider } from '@tanstack/react-query';
import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';

import { AuthProvider } from '@sine/auth-client';
import { TeamSwitcherProvider } from '@sine/sine-team-switcher';
import { NotificationProvider } from '@sine/sine-ui-components';

import App from './App';
import authService from './authentication/auth.service';
import deviceService from './authentication/device.service';
import DeviceContextProvider from './device/DeviceContext';
import { initialiseGlobalEventListeners } from './globalEventListeners';
import handleMFASuccess from './helpers/handleMFALogin';
import './interceptors/axios.interceptor';
import notificationService from './notifications/notificationService';
import { queryClient } from './query.client';
import RoutingRedirect from './routing/RoutingRedirect';
import FeaturesProvider from './shared/providers/FeaturesProvider';
import IntercomProvider from './shared/providers/IntercomProvider';
import LaunchDarklyProvider from './shared/providers/LaunchDarklyProvider';
import NewRelicProvider from './shared/providers/NewRelicProvider';
import teamScopingService from './team/teamScoping.service';
import teamSwitcherService from './team/teamSwitcher.service';
import GlobalStyles from './theme/GlobalStyles';

initialiseGlobalEventListeners();
teamScopingService.initialiseTeamScoping();

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <GlobalStyles />

    <NotificationProvider notificationService={notificationService}>
      <QueryClientProvider client={queryClient}>
        <DeviceContextProvider deviceServiceInstance={deviceService}>
          <AuthProvider authService={authService} onMFASuccess={handleMFASuccess}>
            <TeamSwitcherProvider teamSwitcherService={teamSwitcherService}>
              <IntercomProvider>
                <NewRelicProvider>
                  <BrowserRouter basename={window.env.PUBLIC_URL}>
                    <LaunchDarklyProvider>
                      <FeaturesProvider>
                        <RoutingRedirect>
                          <App />
                        </RoutingRedirect>
                      </FeaturesProvider>
                    </LaunchDarklyProvider>
                  </BrowserRouter>
                </NewRelicProvider>
              </IntercomProvider>
            </TeamSwitcherProvider>
          </AuthProvider>
        </DeviceContextProvider>
      </QueryClientProvider>
    </NotificationProvider>
  </StrictMode>,
);
